import React from "react";
import styles from "./style.module.css";

import "rc-slider/assets/index.css";

import Slider, { Range } from "rc-slider";

import { LineInput } from "components/Inputs/LineInput";

export default class ProjectSlider extends React.PureComponent {
  render() {
    const {
      min,
      max,
      label,
      color,
      onChange,
      onAfterChange,
      value,
      step,
      marks,
      isDollar,
      isLocked,
      isWideLabel,
      hideSlider,
      className,
      style,
      endLabel,
      inputWidth
    } = this.props;

    return (
      <div
        className={(className ? className : "") + " " + styles.projectSliderHolder}
        style={style ? { ...style } : {}}
      >
        {hideSlider !== true && (
          <div className={styles.inputSlider}>
            <Slider
              type="range"
              min={min}
              max={max}
              onChange={isLocked || onChange === undefined ? () => {} : (value) => onChange(Number(value))}
              onAfterChange={
                isLocked || onAfterChange === undefined ? () => {} : (value) => onAfterChange(Number(value))
              }
              value={Number(value)}
              step={step ? step : 1}
              marks={marks}
              trackStyle={{ backgroundColor: color ? color : "#7E69D7" }}
              handleStyle={
                isLocked
                  ? {
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      borderColor: "rgba(0, 0, 0, 0)"
                    }
                  : {
                      backgroundColor: "#7E69D7",
                      borderColor: "white",
                      boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)"
                    }
              }
            />
          </div>
        )}
        <div className={styles.projectInput} style={{ width: "75px" }}>
          <LineInput
            min={min}
            max={max}
            style={{ height: "30px" }}
            onChange={(val) => {
              if (onChange !== undefined) {
                onChange(val);
              }

              if (onAfterChange !== undefined) {
                onAfterChange(val);
              }
            }}
            value={value}
            isDollar={isDollar}
            isMediumBox
            isDisabled={isLocked}
          />
        </div>
      </div>
    );
  }
}
